import React, {
    useMemo,
    useState,
    useEffect,
    useCallback,
    useRef,
} from "react";
import {
    Row,
    Col,
    Button,
    Modal,
    Form
} from "react-bootstrap";
import { logout } from "../../utils";
import { toast } from "react-toastify";
import { getFromLS } from "../../utils/storage";
import { FormContext } from "../../reusable-components/InputFields/FormContext";
import Element from '../../reusable-components/InputFields/input';
import * as Icon from "react-bootstrap-icons";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine-dark.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import "ag-grid-community/dist/styles/ag-theme-material.css";
import "ag-grid-community/dist/styles/ag-theme-balham.css";
import "ag-grid-community/dist/styles/ag-theme-balham-dark.css";
 
import { Bars } from "react-loader-spinner";
import { PreviewFullWindowModal } from "../../pages/DynamicForm/myforms/PreviewFullWindowModal";
import { json, useNavigate } from "react-router-dom";
import Select from 'react-select';

const ClientOnboarding = (props) => {
    const [data, setData] = useState({ "data": [] })
    const [rowData, setRowData] = useState([])
    const [previewComponents, setPreviewComponents] = useState([])
    const [formTitle, setFormTitle] = useState("")
    const [formUrl, setFormUrl] = useState("")
    const [formDescription, setFormDescription] = useState("")
    const [previewFullWindowModalShow, setPreviewFullWindowModalShow] = useState(false)
    const [formOptions, setFormOptions] = useState([{ value: '', label: '' }])
    const [selectedFormOptions, setSelectedFormOptions] = useState({ value: '', label: '' })


    const postOptions = {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        body: JSON.stringify({
            "FormPurpose": "Client Onboarding"
        }),
    };

    useEffect(() => {
        fetch(`${process.env.REACT_APP_BASE_URI}/workflow/forms/type/responses/`, postOptions)
            .then((response) => {
                if (!response.ok) {
                    if (response.status === 401) {
                        // Handle unauthorized error
                        logout();
                        alert("Session ended , Please login back");
                    } else {
                        throw new Error("Request failed.");
                    }
                }
                return response.json();
            })
            .then((data) => {
                console.log("DATA TYPE FORMS: ", data)
                setData(data)
            });
    }, []);

    useEffect(() => {
        const uniqueFormNameList = new Set([])
        for (let record of data["data"]) {
            // form options list mapping below
            uniqueFormNameList.add(record["FormName"])
        }

        const optionList = []
        for (let formName of uniqueFormNameList) {
            const option = { "label": formName, "value": formName }
            optionList.push(option)
        }
        setFormOptions(optionList)
        setSelectedFormOptions(optionList[0])
    }, [data])

    useEffect(() => {
        if (selectedFormOptions !== undefined) {
            const records = data["data"]
            const filteredRecords = records.filter((record) => record["FormName"] === selectedFormOptions["value"])
            console.log("FILTERED RECORDS:", filteredRecords)
            const rData = []
            if (filteredRecords.length > 0) {
                for (let record of filteredRecords) {
                    if (record["FirmFormsResponse"] !== "") {
                        // row data mapping below
                        const newEntry = {}
                        for (let object of JSON.parse(record.Response)) {
                            Object.assign(newEntry, { [object["label"]]: object["value"] })
                        }
                        Object.assign(newEntry, { "previewComponent": JSON.parse(record.Response) })
                        Object.assign(newEntry, { "firmFormResponseId": record.FirmFormsResponse })
                        rData.push(newEntry)
                    }
                }
                console.log("ROW DATA: ", rData)
                setRowData(rData)
                gridParamsMapper(rData)
            }
            setFormTitle(selectedFormOptions["value"])
            setFormDescription("Client onboarding")
        }
    }, [selectedFormOptions])

    // Setting default grid params
    const gridRef = useRef();
    const gridStyle = useMemo(() => ({ height: "100%", width: "100%" }), []);
    const onFirstDataRendered = useCallback((params) => {
        gridRef.current.api.sizeColumnsToFit();
    }, []);

    let gridApi;
    const onGridReady = useCallback((params) => {
        gridApi = params.api;
        gridApi.closeToolPanel();
    }, []);

    const defaultColDef = useMemo(
        () => ({
            filter: true,
            resizable: true,
            animateRows: true,
        }),
        []
    );

    /**
     * A grid cell renderer button.
     * @param {*} props: props include the selected row data for editing.
     * @returns A button for editing the row in grid.
     */
    const BtnCellRenderer = (props) => {
        const editClick = () => {
            console.log("BTN CELL RENDERER PROP: ", props.data)
            props.selectedrow(props.data);
            setPreviewFullWindowModalShow(true)
        }
        return (<Button className="grid-button" onClick={() => editClick()}><Icon.PencilSquare /></Button>);
    }

    // Declaring the api - grid connections
    const [columnDefs, setColumnDefs] = useState([]);
    const [selectedRowData, setSelectedRowData] = useState({ "previewComponent": [] });
    useEffect(() => {
        console.log("SELECTED ROW DATA: ", selectedRowData)
        for (let component of selectedRowData["previewComponent"]) {
            if (!component["show"]) {
                component["show"] = true
            }
        }
        setPreviewComponents(selectedRowData["previewComponent"])
    }, [selectedRowData])

    const onSelectionChanged = () => { const selected_rows = gridRef.current.api.getSelectedRows() };

    const CustomNoRowsOverlay = (props) => {
        return (
            <div
                className="ag-overlay-loading-center flex-row-center-center"
                style={{ height: '9%' }}
            >
                <div className="spinner " style={{ fontSize: 14, fontWeight: 500 }}>
                   {props.noRowsMessageFunc()}
                </div>
            </div>
        );
    };

    const noRowsOverlayComponent = useMemo(() => { return CustomNoRowsOverlay }, []);

    const noRowsOverlayComponentParams = useMemo(() => { return { noRowsMessageFunc: () => `No data for ${formTitle} client onboarding yet. Please add new records first.` } }, []);

    /**
    * This function is used for formatting the default column names of the grid
    * @param {*} defaultName: Current name from API
    * @returns: Final column name
    */
    const GridColumnTitleRenderer = (defaultName) => {
        const splitWords = defaultName.split("_")
        for (let word in splitWords) {
            splitWords[word] = splitWords[word].charAt(0).toUpperCase() + splitWords[word].slice(1)
        }
        return splitWords.join(" ")
    }

    /**
     * This function takes the API response data and maps it to the grid params
     * @param {*} result: API response
     */
    const gridParamsMapper = (rowData) => {
        if (rowData.length != 0) {
            const keys = Object.keys(rowData[0]).slice(0, -2) // skipping the previewcomponents and firmformresponseid
            let jsonColDefs = keys.map(key => {
                return {
                    field: key, headerName: GridColumnTitleRenderer(key)
                }
            });
            let colDefs = [{
                field: "", headerName: "Actions",
                cellStyle: { 'border-right-color': '#ccc' },
                maxWidth: 75,
                width: 75,
                suppressMenu: true,
                cellRenderer: BtnCellRenderer,
                cellRendererParams: {
                    selectedrow: setSelectedRowData
                }
            }].concat(jsonColDefs)
            setColumnDefs(colDefs)
        }
    }

    /**
     * Update the values of fields in the PREVIEW form
     * @param {*} field_id: ID of field to be updated 
     * @param {*} event: The trigger event of input in preview form
     */
    const handleChange = (field_id, event) => {
        const newList = [...previewComponents]
        newList.forEach(field => {
            const { type, id } = field;
            if (field_id === id) {
                switch (type) {
                    case 'checkbox':
                        field['value'] = event.target.checked;
                        break;

                    case 'select':
                        field['value'] = event.value;
                        break;

                    case 'file':
                        field['value'] = event[0];
                        break;

                    case 'date':
                        field['value'] = event;
                        break;

                    default:
                        field['value'] = event.target.value;
                        break;
                }
            }
            const newListTwo = [...newList]
            setPreviewComponents(newListTwo)
        })
    }

    const updateData = (firmFormResponseId) => {
        let payloadFormat;
        payloadFormat = {
            "FirmFormsResponse": firmFormResponseId,
            "Response": previewComponents
        }
        console.log("PAYLOAD FORMAT: ", payloadFormat)
        const token = getFromLS("token")
        const postOptions = {
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify(payloadFormat),
        };

        fetch(`${process.env.REACT_APP_BASE_URI}/workflow/forms/${formUrl}/`, postOptions)
            .then((response) => {
                if (!response.ok) {
                    if (response.status === 401) {
                        // Handle unauthorized error
                        logout();
                        alert("Session ended , Please login back");
                    } else {
                        throw new Error("Request failed.");
                    }
                }
                return response.json();
            })
            .then((data) => {
                if (data.success == true) {
                    toast.success(
                        " Entry successfully updated!",
                        {
                            position: "bottom-right",
                            autoClose: 2500,
                            hideProgressBar: true,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            className: "toastify-color-success",
                        }
                    );
                } else {
                    toast.error(
                        "Saving failed, " + data.message,
                        {
                            position: "bottom-right",
                            autoClose: 2500,
                            hideProgressBar: true,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            className: "toastify-color-error",
                        }
                    );
                }
            })
            .catch((err) => console.log("Err: ", err));
    }

    const navigate = useNavigate()

    return (
        <>
            {data["message"] !== undefined
                ?
                <>
                    <PreviewFullWindowModal
                        show={previewFullWindowModalShow}
                        onHide={() => setPreviewFullWindowModalShow(false)}
                        previewcomponents={previewComponents}
                        formtitle={formTitle}
                        formurl={formUrl}
                    />
                    <Row className='no-gutter'>
                        <Col md={6} className="flex-row-space-center" style={{ padding: "0px 20px 0px 10px" }}>
                            <p className="display-6" style={{ height: "fit-content", marginBottom: 10, width: "fit-content" }}>{formDescription} records</p> <p style={{ width: "fit-content" }}></p>
                        </Col>
                        <Col md={6} className="flex-row-space-center">
                            <div className="form-select-wrapper">
                                <p style={{ fontWeight: 900, marginRight: "0.75rem", width: 100 }}>Client type: </p>
                                <Select
                                    value={selectedFormOptions}
                                    onChange={(e) => setSelectedFormOptions(e)}
                                    options={formOptions}
                                    className="form-select custom-select"
                                    aria-label="Default"
                                    closeMenuOnSelect={true}
                                    autosize={true}
                                    placeholder="Filter by form"
                                    menuPosition="fixed"
                                    classNamePrefix="react-select"
                                />
                            </div>
                            <div className="navigator" style={{ float: "right", width: "fit-content", marginBottom: "-1rem" }}>
                                <Button className="nav-direction" onClick={() => navigate("/clientonboarding")}><Icon.CaretLeftFill /> Configure client onboarding</Button>
                            </div>
                        </Col>
                    </Row>
                    <Row className='no-gutter' style={{ height: "85vh" }}>
                        <Col md={12}>
                            <div className="ag-theme-balham" style={gridStyle}>
                                <AgGridReact
                                    ref={gridRef}
                                    rowData={rowData}
                                    columnDefs={columnDefs}
                                    defaultColDef={defaultColDef}
                                    onGridReady={onGridReady}
                                    alwaysShowHorizontalScroll={false}
                                    alwaysShowVerticalScroll={false}
                                    rowHeight={50}
                                    rowSelection={"single"}
                                    suppressContextMenu={true}
                                    onFirstDataRendered={onFirstDataRendered}
                                    noRowsOverlayComponent={noRowsOverlayComponent}
                                    noRowsOverlayComponentParams={noRowsOverlayComponentParams}
                                />
                            </div>
                        </Col>
                    </Row>
                </>
                :
                <div
                    className="flex-row-center-center"
                    style={{ marginTop: "20%" }}
                >
                    <div className="spinner " style={{ fontSize: 14, fontWeight: 500 }}>
                        <Bars
                            height="80"
                            width="80"
                            color="var(--theme1_primary)"
                            ariaLabel="bars-loading"
                            wrapperStyle={{}}
                            wrapperClass=""
                            visible={true}
                        />

                        Loading your data
                    </div>
                </div>
            }
        </>
    )
}

export default ClientOnboarding;